import { render, staticRenderFns } from "./SalesResenderTable.vue?vue&type=template&id=27ad1c6b&"
import script from "./SalesResenderTable.vue?vue&type=script&lang=js&"
export * from "./SalesResenderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports